import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './recipient-description.module.scss';

const RecipientDescription = props => {
  const { className, huggg } = props;

  return huggg.purchase.recipient_description ? (
    <div className={classnames(className, styles.copy)}>
      {huggg.purchase.recipient_description}
    </div>
  ) : null;
};

RecipientDescription.propTypes = {
  huggg: PropTypes.object.isRequired,
  className: PropTypes.string
};

export default RecipientDescription;
